import type { KeyboardEvent } from 'react';

const NEXT = new Set(['ArrowRight', 'ArrowDown']);
const PREVIOUS = new Set(['ArrowLeft', 'ArrowUp']);

/**
 * Arrow keys, Home and End move the choice within a `role="radiogroup"`
 * whose radios use a roving `tabIndex` (0 on the checked one, -1 elsewhere).
 */
export function onRadioGroupKeyDown(event: KeyboardEvent<HTMLElement>) {
  const { key } = event;
  if (!NEXT.has(key) && !PREVIOUS.has(key) && key !== 'Home' && key !== 'End') {
    return;
  }
  const radios = Array.from(
    event.currentTarget.querySelectorAll<HTMLElement>('[role="radio"]')
  );
  const current = radios.indexOf(event.target as HTMLElement);
  if (current === -1) return;
  event.preventDefault();
  const last = radios.length - 1;
  const next =
    key === 'Home'
      ? 0
      : key === 'End'
        ? last
        : NEXT.has(key)
          ? (current + 1) % radios.length
          : (current - 1 + radios.length) % radios.length;
  radios[next].focus();
  radios[next].click();
}
